import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import parse from "html-react-parser"
import classnames from "classnames"

import Modal from "shared/components/modal"
import { reportChannelFeedbackAbuse } from "shared/lib/graphql"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"
import displayFlash from "partners/scripts/display_flash"
import thumbsUp from "images/partners/feedback/thumbs-up.svg?raw"
import thumbsDown from "images/partners/feedback/thumbs-down.svg?raw"
import styles from "./platform_feedback.module.scss"

export default class PlatformFeedbackCard extends Component {
  state = {
    modalOpen: false,
    reported: false,
  }

  opinionCodeMap = {
    not_useful: "Not useful",
    too_slow: "Too slow",
    unexpected: "Doesn't work as expected",
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  reportFeedback = () => {
    const { feedbackType, id } = this.props
    reportChannelFeedbackAbuse(feedbackType, id, false)
      .then(() => {
        this.setState({ modalOpen: false, reported: true }, () => {
          displayFlash("Feedback has been reported")
        })
      })
      .catch(
        rejectedXHRPromiseLogger(() => {
          displayFlash("An error has occurred please contact an administrator", "error")
        })
      )
  }

  renderAppletFeedbackResponse = () => {
    const { feedbackType, like } = this.props
    if (feedbackType === "applet_feedback") {
      return like ?
        <span className={classnames("thumbs up", styles["thumbs"], styles.up)}>{parse(thumbsUp)}</span> :
        <span className={classnames("thumbs down", styles["thumbs"], styles.down)}>{parse(thumbsDown)}</span>
    }

    return null
  }

  render() {
    if (this.state.reported) {
      return null
    }

    const {
      profileImgUrl,
      userLogin,
      suggestionName,
      text,
      createdAt,
      channelInfo,
      contextChannelPublished,
      feedbackType,
      like,
      opinionCode,
      userProfileLink,
    } = this.props

    return (
      <div className={classnames("platform-feedback-card", styles["platform-feedback-card"])}>
        <div className={classnames("feedback-card-header", styles["feedback-card-header"])}>
          <span className={classnames("feedback-header-container", styles["feedback-header-container"])}>
            <a href={userProfileLink}>
              <span
                style={{
                  backgroundImage: `url(${profileImgUrl || window.App.defaultProfileIconUrl})`,
                }}
              />
            </a>
            <b>{userLogin}</b>
            {contextChannelPublished && channelInfo && (
              <span className={classnames("channel-info-container", styles["channel-info-container"])}>
                with
                <span
                  style={{
                    backgroundColor: `#${channelInfo.brand_color}`,
                  }}
                >
                  <img src={channelInfo.monochrome_image_url} alt={channelInfo.name} title={channelInfo.name} />
                  {channelInfo.name}
                </span>
              </span>
            )}
          </span>
          <span className={classnames("feedback-header-container", styles["feedback-header-container"])}>
            <span className={classnames("timestamp", styles.timestamp)}>
              {moment(new Date(createdAt), "YYYYMMDD").fromNow()}
            </span>
            <span className={classnames("report-tag", styles["report-tag"])} onClick={this.toggleModal}>
              Report
            </span>
          </span>
        </div>
        <div className={classnames("feedback-card-body", styles["feedback-card-body"])}>
          {this.renderAppletFeedbackResponse()}
          <div>
            <div className={styles["opinion-text"]}>
              {suggestionName}: {text}
            </div>
            {feedbackType === "applet_feedback" && like === false && opinionCode && (
              <div>
                <span>Reason: </span>
                <span>{this.opinionCodeMap[opinionCode]}</span>
              </div>
            )}
          </div>
        </div>
        <Modal
          closeListener={this.toggleModal}
          show={this.state.modalOpen}
          headerText={"Report Abusive Feedback"}
          includeCloseX={false}
        >
          <div className={classnames("feedback-card-modal", styles["feedback-card-modal"])}>
            <div className={classnames("feedback-modal-content", styles["feedback-modal-content"])}>
              Are you sure you want to report this feedback?
            </div>
            <div className={classnames("modal-button-container", styles["modal-button-container"])}>
              <button className="button-tertiary button-outlined" onClick={this.toggleModal}>
                Cancel
              </button>
              <button className="button-tertiary" onClick={this.reportFeedback}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

PlatformFeedbackCard.propTypes = {
  feedbackType: PropTypes.string,
  id: PropTypes.number,
  createdAt: PropTypes.string,
  suggestionName: PropTypes.string,
  text: PropTypes.string,
  userLogin: PropTypes.string,
  profileImgUrl: PropTypes.string,
  channelInfo: PropTypes.shape({
    monochrome_image_url: PropTypes.string,
    brand_color: PropTypes.string,
    name: PropTypes.string,
  }),
  contextChannelPublished: PropTypes.bool,
  like: PropTypes.bool,
  opinionCode: PropTypes.string,
  userProfileLink: PropTypes.string,
}
